import { baseTheme } from "./base";
export const fontTokens = {
    font01: ["2.625rem", "3.25rem"],
    font02: ["2.625rem", "3.25rem"],
    font03: ["2.25rem", "2.75rem"],
    font04: ["2rem", "2.5rem"],
    font05: ["1.75rem", "2.25rem"],
    font06: ["1.625rem", "2rem"],
    font07: ["1.5rem", "2rem"],
    font08: ["1.375rem", "1.75rem"],
    font09: ["1.25rem", "1.75rem"],
    font10: ["1.125rem", "1.5rem"],
    font11: ["1rem", "1.5rem"],
    font12: ["0.875rem", "1.25rem"],
    font13: ["0.8125rem", "1rem"],
    font14: ["0.75rem", "1rem"],
    defaultFont: "'AktivGrotesk', helvetica, arial, sans-serif",
};
export const comTheme = Object.assign(Object.assign({}, baseTheme), { fontTokens });
